
import layerEvents from "../utils/layerEvents";
import { Button, Dropdown, Accordion, Modal} from "react-bootstrap";
import { PencilSimple, Lightning, Windmill, BatteryCharging, BatteryFull, Spiral, Ruler, Crosshair, X, Info, Eye, Trash, DotsThreeVertical, Wind, Calculator, Warning, CircleNotch, Plus, Waveform, Moon, MapPinSimple, ArrowsOutCardinal, ClockCounterClockwise } from "@phosphor-icons/react";
import DataTable from 'react-data-table-component';
import vindrApi from "../utils/vindrapi";
import {
	format_power,
	processOwnersAndLands,
	updateGeoJsonLayer
}							from "../utils/functions";
import EditNow from "../components/EditNow";
import DoNowButton from "../components/DoNowButton";
import ReactDOM from "react-dom/client";
import clickableMarker from "../utils/clickableMarker";
import Tool from "../classes/Tool";
import DialogScenarioCopyFromChange from "../layouts/DialogScenarioCopyFromChange";



export class ToolHistory extends Tool {


	tabIndex			= null;

	constructor(p, mode=false) {
		super();
		this.tc			= p;
		this.silent = mode;
	
		
	}

	update(){
		

	}
	init(){
		this.showHeader();
		document.querySelector("#root").classList.add("historymode");
		this.display();
		this.backupScenario = structuredClone(this.tc.scenario);
		this.getHistory();
		
		setTimeout(()=>{
			this.tc.map.resize();
		},300);
	}
	getHistory(){
		return vindrApi.getScenarioChanges(this.tc.scenario.projectid, this.tc.scenario.scenario_id, 50)
		.then((res) => {
			ToolHistory.history = res;
			if(Array.isArray(res)){
				this.processChanges(res);
				this.display();
			}
		})
		.catch(() => {});
	}
	processChanges(res){
		const groups = {};

		res.forEach(event => {
			const date = event.timestamp.split('T')[0];
			if(!groups[date])
				groups[date] = [];
			groups[date].push(event);
		});

		this.groupedChanges = Object.entries(groups)
			.sort(([a], [b]) => b.localeCompare(a))
			.map(([date, events]) => ({ date, events }));

		return this.groupedChanges;
	}
	
	exit(){
		document.querySelector("#root").classList.remove("historymode");
		this.previewChangeId = null;
		this.exitPreview();
		if(this.tc.serviceBar.current)
			this.tc.serviceBar.current.clear(this.tabIndex);
		this.tabIndex = null;
		this.closeHeader();
		this.restoreBuffer = null;
	}

	showRestoreDialog(changeId){
		const pId = this.tc.scenario.projectid;
		const sId = this.tc.scenario.scenario_id;
		const doThis = () => {
			this.confirmChangeId = changeId;
			this.display();
		}
		
		
		if(!this.previewChangeId || (this.previewChangeId != changeId)){
			vindrApi.getChangePreview(pId, sId, changeId)
			.then((data) => {
				this.restoreBuffer = data;
				doThis();
			})
			.catch(() => {});
		}
		else
			doThis();

	}
	hideRestoreDialog(changeId){
		this.confirmChangeId = null;
		this.display();
	}

	restoreVersion(changeId){
		const pId = this.tc.scenario.projectid;
		const sId = this.tc.scenario.scenario_id;
		const {QN} = this.tc.draw.context;

		const change = (ToolHistory.history ?? []).find(a => a.id === changeId);

		vindrApi[change?.undone ? 'redoChange':'undoChange'](pId, sId, changeId).then((res) => {
			this.tc.checkOutdated(res, false);
			if(this.restoreBuffer){
				this.applyPreview(this.restoreBuffer);
				this.restoreBuffer = null;
			}
			QN.current.show("Restored to this version.", <Button variant="primary btn-sm" onClick={()=>{this.redo()}} >Undo</Button>);
			this.backupScenario = null;
			this.hideRestoreDialog();
			this.tc.exitSecondary();
		})
		.catch(() => {});
	}
	redo(){
		const pId = this.tc.scenario.projectid;
		const sId = this.tc.scenario.scenario_id;
		const {QN} = this.tc.draw.context;
		vindrApi.redoChange(pId, sId, false)
			.then((res) => {
				this.tc.checkOutdated(res, false);
				QN.current.show("Restored to the latest version");
				this.tc.exitSecondary();
			})
			.catch(() => {});
	}

	countChangesSince(changeId){
		if(!this.groupedChanges) return 0;
		let count = 0;
		for(const group of this.groupedChanges){
			for(const event of group.events){
				if(event.id === changeId) return count;
				count++;
			}
		}
		return count;
	}

	formatTimeVerbose(timestamp){
		const now = new Date();
		const t = new Date(timestamp);
		const time = t.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
		if(t.toDateString() === now.toDateString()) return `Today - ${time}`;
		if(t.toDateString() === new Date(now - 86400000).toDateString()) return `Yesterday - ${time}`;
		return `${t.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })} - ${time}`;
	}

	previewVersion(event){
		const pId = this.tc.scenario.projectid;
		const sId = this.tc.scenario.scenario_id;
		this.previewChangeId = event.id;
		this.display();
		this.showHeader(event);
		vindrApi.getChangePreview(pId, sId, event.id)
			.then((data) => {
				if(this.applyPreview)
					this.applyPreview(data);
			})
			.catch(() => {});
	}
	applyPreview(res){
		if(res && res.scenario_id !== undefined){
			
			//activate all system layers
			if(Array.isArray(res.layers)){
				res.layers.forEach((l)=>{
					if(!l.data.vindrid)
						l.data.defaultChecked = true;
				});
			}
			
			res.wtgs.forEach((t, idx)=>{
				const old = this.tc.scenario.wtgs.find((o)=>{return o.turbineid == t.turbineid})
				if(old){
					res.wtgs[idx] = {...old, ...t}
				}
			});
			res.nsas.forEach((s, idx)=>{
				const old = this.tc.scenario.nsas.find((o)=>{return o.nsaid == s.nsaid})
				if(old){
					res.nsas[idx] = {...old, ...s}
				}
			});
			
			const s = {...this.tc.scenario, ...res};

			this.tc.setScenario(s);
			this.tc.infoLayers.current.redraw();
		}
	}

	exitPreview(){
		
		if(this.tc.scenario_id == this.backupScenario?.scenario_id)
			return;
		this.previewChangeId = null;
		if(this.backupScenario)
			this.applyPreview(this.backupScenario);
		this.display();
	}
	
	formatDate(dateStr){
		const days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
		const d = new Date(dateStr + 'T12:00:00');
		const [year, month, day] = dateStr.split('-');
		return `${days[d.getDay()]} ${day}.${month}.${year}`;
	}

	formatTime(timestamp){
		const now = new Date();
		const t = new Date(timestamp);
		const diffMin = Math.floor((now - t) / 60000);
		if(diffMin < 60)   return `${diffMin}m ago`;
		if(diffMin < 1440) return `${Math.floor(diffMin / 60)}h ago`;
		return t.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
	}

	getIcon(event){
		if(event.action === 'create') return <Plus weight="bold" size={24} />;
		if(event.action === 'delete') return <Trash weight="bold" size={24} />;
		if(event.entity_type === 'turbine') return <ArrowsOutCardinal weight="bold" size={24} />;
		if(event.entity_type === 'nsa') return <MapPinSimple weight="bold" size={24} />;
		return <PencilSimple weight="bold" size={24} />;
	}
	showHeader(data){
		var wrp = document.createElement("div");
		wrp.className = "history-header" + (data ? " active" : "");
		
		this.closeHeader(false);
		
		document.querySelector(".header").appendChild(wrp);
		
		ReactDOM.createRoot(wrp).render(
			<>
				<div className="menu">
				
				</div>
				
				<div className="middle">
					<div className="title project-name">
						{data ? data.description : this.tc.draw.context.getters.project.name}
						
					</div>
					<div className="text-muted">{ data ? this.formatDate(data.timestamp.split('T')[0])+" "+this.formatTime(data.timestamp) : 'current version' } </div>

				</div>
				<div className="logo">
					<img className="img-fluid d-none d-md-block brand-logo" src="/images/vindr_logo_blue.svg" alt="Vindr"/>
				</div>
				<div className="options">
					<Button onClick={(e)=>{this.tc.exitSecondary(e);}} variant="outline-primary closeHistory"><X size={16} weight="bold" /></Button>	
				</div>
			</>
		);
		if(!data)
			setTimeout(()=>{ wrp.classList.add("active");},10);
		
		
	}
	closeHeader(animate = true) {
		

		var a = false;
		if(a = document.querySelector(".history-header")){
			a.classList.remove("active");
			if(!animate)
				a.remove();
			else
				setTimeout(()=>{ a.remove(); },300);
			
		}
		
		
	}
	copyVersion(id){
		this.copyVersionId = id;
		this.display();
	}
	handleCopy = () => {
		
	}
	display = ()=>{
		
		if(this.silent)
			return;
		if(this.tc.serviceBar.current && (this.tc.secondaryHandler && this.tc.secondaryHandler.constructor.name == this.constructor.name))
			this.tabIndex =	this.tc.serviceBar.current.inject(this.render(), this.tabIndex);
	}
	render(){
		const isPreviewing = !!this.previewChangeId;
		const isMain = !this.tc.scenario.scenario_id;

		let previewedChange = null;
		if(isPreviewing && this.groupedChanges){
			for(const group of this.groupedChanges){
				const found = group.events.find(e => e.id === this.previewChangeId);
				if(found){ previewedChange = found; break; }
			}
		}

		const confirmChange = this.confirmChangeId && this.groupedChanges
			? this.groupedChanges.flatMap(g => g.events).find(e => e.id === this.confirmChangeId)
			: null;
		const changesSince = confirmChange ? this.countChangesSince(this.confirmChangeId) : 0;

		const closeDialog = () => { this.confirmChangeId = null; this.display(); };
		const closeCopyDialog = () => { this.copyVersionId = null; this.display(); };

		const changeOptions = this.groupedChanges
			? this.groupedChanges.flatMap(g => g.events).map(e => ({
				value: e.id,
				label: `${e.username || 'You'} — ${e.description} (${this.formatTimeVerbose(e.timestamp)})`
			}))
			: [];
		const copyDefaultValue = changeOptions.find(o => o.value === this.copyVersionId) ?? null;
	
		var undone = true;
		
		const current = ToolHistory.history ? ToolHistory.history.find((a)=>{return a.undone === false;}).id : 0;
		return (
			<div className="project-history">
				<div className="title">
					Version history 
					<div className="branded-tooltip">
						<Info size={16} weight="bold" />
						<div className="text">
							<span><Info size={16} weight="bold" /> Information </span>

							Version history shows a history of actions performed in the toolbar, such as adding, deleting, editing, or moving objects in map.
						</div>
					</div>
				</div>

				<div className="scroll">
					<div className="content p-0 changelog-panel pt-4">
						{typeof this.groupedChanges == 'undefined' ? (
							<div className="p-3 text-center">
								<CircleNotch size={20} className="spin" />
							</div>
						) : this.groupedChanges.length === 0 ? (
							<div className="p-4 text-center text-muted">
								<ClockCounterClockwise size={32} className="mb-2 opacity-50" />
								<div>No past changes recorded.</div>
							</div>
						) : (
							<Accordion defaultActiveKey={["0"]} alwaysOpen flush>
								{this.groupedChanges.map((group, idx) => (
									<Accordion.Item eventKey={String(idx)} key={group.date}>
										<Accordion.Header>
											<span className="flex-grow-1">{this.formatDate(group.date)}</span>
											{idx === 0 && <span className="text-muted small me-2">Current version</span>}
										</Accordion.Header>
										<Accordion.Body className="p-0">
											{group.events.map((event) => {

												if(typeof event.undone == "boolean")
													undone = event.undone;
												return (
													<div key={event.id} className={`history-event d-flex align-items-start gap-3 px-3 py-2 ps-5${(this.previewChangeId === event.id || (!this.previewChangeId && current === event.id)) ? ' active' : ''} ${event.undone ? ' undone' : ''}`} onClick={(e) => { e.preventDefault(); this.previewVersion(event); }}>
														<div className="history-icon mt-1 ml-3">
															{this.getIcon(event)}
														</div>
														<div className="flex-grow-1">
															<div className="description">
																<strong>{event.username || 'You'}</strong> {event.description}
															</div>
															<div className="text-muted small">
															{this.formatTime(event.timestamp)} {current == event.id && <span className="current-text">Current version</span>}
															</div>
														</div>
														<div className="history-icon mt-1 ml-3">
															<Dropdown className="minimal">
																<Dropdown.Toggle className="p-0 px-1" variant="default">
																	<DotsThreeVertical size={16} />
																</Dropdown.Toggle>
																<Dropdown.Menu>
																	<Dropdown.Item href="#" onClick={(e) => { e.preventDefault(); this.copyVersion(event.id); }}><Eye size={16} /> Copy to scenario</Dropdown.Item>
																	{!isMain && <Dropdown.Item href="#" onClick={(e) => { e.preventDefault(); this.showRestoreDialog(event.id); }} className="text-danger"><ClockCounterClockwise size={16} /> Restore this version</Dropdown.Item>}
																</Dropdown.Menu>
															</Dropdown>
														</div>
													</div>
												)}
											)}
										</Accordion.Body>
									</Accordion.Item>
								))}
							</Accordion>
						)}
					</div>
				</div>
				
				{isPreviewing && (current != this.previewChangeId) && (
					<div className="preview-footer d-flex align-items-center gap-2 p-3 border-top">
						{isMain ? (
							<button className="btn btn-dark" onClick={() => this.copyVersion(this.previewChangeId)}>Copy to scenario</button>
						) : (
							<>
								<button className="btn btn-dark" onClick={() => this.showRestoreDialog(this.previewChangeId)}>Restore this version</button>
								<button className="btn btn-outline-secondary" onClick={() => this.copyVersion(this.previewChangeId)}>Copy to scenario</button>
							</>
						)}
						<button className="btn btn-link preview-footer__cancel" onClick={() => this.exitPreview()}>Cancel</button>
					</div>
				)}

				<Modal show={!!this.confirmChangeId} onHide={closeDialog} centered className="restore-dialog">
					<Modal.Header>
						<Modal.Title>Restore this version</Modal.Title>
						<button className="btn btn-close alt btn-sm float-end" onClick={closeDialog}></button>
					</Modal.Header>
					<Modal.Body>
						{confirmChange && (
							<>
								<div className="mb-1">
									<strong>{confirmChange.username || 'You'}</strong> {confirmChange.description}
								</div>
								<div className="text-muted small mb-3">{this.formatTimeVerbose(confirmChange.timestamp)}</div>
								<hr className="my-3" />
							</>
						)}
						<p className="mb-0">
							The <span className="text-danger">{changesSince} {changesSince === 1 ? 'change' : 'changes'}</span> made after this version will be <span className="text-danger">discarded</span>. {changesSince === 1 ? 'It' : 'They'} can only be restored until a new change is made.
						</p>
					</Modal.Body>
					<Modal.Footer className="border-0">
						<button className="btn btn-outline-secondary" onClick={closeDialog}>Cancel</button>
						<button className="btn btn-dark" onClick={() => this.restoreVersion(this.confirmChangeId)}>Restore this version</button>
					</Modal.Footer>
				</Modal>
				
				<DialogScenarioCopyFromChange
					setup={{
						open:          !!this.copyVersionId,
						changeOptions: changeOptions,
						defaultValue:  copyDefaultValue,
						projectid:     this.tc.scenario.projectid,
						scenarioid:    this.tc.scenario.scenario_id,
					}}
					onClose={closeCopyDialog}
				/>
			</div>
		);
	}
}
